import { render } from "./jingongAndweixianjingong.vue?vue&type=template&id=463ca3ef&scoped=true"
import script from "./jingongAndweixianjingong.vue?vue&type=script&lang=js"
export * from "./jingongAndweixianjingong.vue?vue&type=script&lang=js"

import "./jingongAndweixianjingong.vue?vue&type=style&index=0&id=463ca3ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463ca3ef"]])

export default __exports__